import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router';
import { Spin } from 'antd';

const ReferenceDataManagementPage = lazy(() => import('./reference-data-management-page.tsx'));

/**
 * No permission gating here — Fund/Share Class reference-data management is available
 * to every authenticated user from the frontend. The backend controllers still enforce
 * role-based authorization (see `FundReferenceDataController` / `ShareClassReferenceDataController`),
 * so unauthorized write attempts are rejected server-side regardless of this page's UI.
 */
export const referenceDataRoutes: RouteObject = {
  path: 'reference-data',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spin />}>
          <ReferenceDataManagementPage />
        </Suspense>
      ),
    },
  ],
};
